import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Flex } from "common/components/flex/flex";
import * as styles from "./eligibilityTag.module.scss";

export const EligibilityTag = ({ isEligible, style = {} }) => (
  <Flex
    align="center"
    gap={4}
    className={styles.eligibilityTag}
    style={{
      color: isEligible ? "var(--green-200)" : "var(--gray-600)",
      ...style,
    }}
  >
    {isEligible ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
    <span className="text-secondary font-style-italic">
      {isEligible ? "Eligible" : "Not Eligible"}
    </span>
  </Flex>
);
